interface ITickerConfig {
   fps: number,
   paused?: boolean,
}
interface ITickerCore {
   curTimestamp: number,
   lastTimestamp: number,
   interval: number,
   delta: number,
   draw: () => void,
   curDrawTimestamp: number,
   lastDrawTimestamp: number,
   drawDelta: number,
   drawFps: number,
}

const config: ITickerConfig = {
   fps: 30,
   paused: false,
}
const core: ITickerCore = {
   curTimestamp: 0,
   lastTimestamp: 0,
   interval: 0,
   delta: 0,
   draw: () => {/**/},
   curDrawTimestamp: 0,
   lastDrawTimestamp: 0,
   drawDelta: 0,
   drawFps: 0,
}


function start(draw: () => void, options?: ITickerConfig) {
   if (options) {
      config.fps = options.fps
      config.paused = options.paused
   }

   core.curTimestamp = 0
   core.lastTimestamp = Date.now()
   core.interval = 1000 / config.fps
   core.draw = draw
   core.curDrawTimestamp = 0
   core.lastDrawTimestamp = Date.now()
   tick()
}

function pause() {
   config.paused = true
}

function tick() {
   if (config.paused) {
      return
   }
   requestAnimationFrame(tick)
   core.curTimestamp = Date.now()
   core.delta = core.curTimestamp - core.lastTimestamp
   core.curDrawTimestamp = Date.now()
   if (core.delta > core.interval) {
      core.lastTimestamp = core.curTimestamp - (core.delta % core.interval)
      core.draw()
      core.drawDelta = core.curDrawTimestamp - core.lastDrawTimestamp
      core.drawFps = 1000 / core.drawDelta
      core.lastDrawTimestamp = Date.now()
   }
}

export default {
   start,
   pause,
   config,
   core,
}
